/**
 * @file XCOMM Selected Identity related fragments.
 */

import gql from 'graphql-tag';

import { UniformAlbumFolderTagLevelTeam } from '../../../../graphql/fragments/album-folder-tags';

export const SelectedIdentityTagDetails = gql`
  fragment SelectedIdentityTagDetails on SelectedIdentity {
    id
    album_membership {
      id
      album {
        id
        album_folder_tags {
          records {
            id
            ... on AlbumAlbumFolderTag {
              id
              album_folder_tag {
                ... on IRecord {
                  id
                }
              }
              uniform_album_folder_tag_levels {
                records {
                  id
                  uniform_album_folder_tag_level {
                    id
                  }
                  uniform_album_folder_tag_level_jerseys {
                    records {
                      id
                      name
                      colors
                      venue
                      team {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    album_folder_tags {
      records {
        id
        ... on IdentityUniformAlbumFolderTag {
          id
          album_folder_tag {
            ... on IRecord {
              id
            }
            ... on IAlbumFolderTag {
              type
            }
          }
          jersey_number
          uniform_album_folder_tag_level_team {
            ...UniformAlbumFolderTagLevelTeam
          }
          uniform_album_folder_tag_level {
            id
            jerseys {
              records {
                id
                name
                colors
                team {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
  ${UniformAlbumFolderTagLevelTeam}
`;

export const SelectedIdentityReferenceFacesDetails = gql`
  fragment SelectedIdentityReferenceFacesDetails on SelectedIdentity {
    reference_faces(active_only: true) {
      total
      records {
        id
        face {
          id
          facebox
          photo {
            id
            thumbnail_urls {
              size_code
              url
              width
              height
              quality
              mime_type
            }
          }
        }
        selfie_source
      }
    }
  }
`;
